import React from 'react';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { pdpSectionStyle } from 'common/components/page-section/pdp-styles';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { getSource } from 'features/product-info';
import { pimDisclaimerSection } from './pim-disclaimer.styles';

type PimDisclaimerProps = {
  className?: string;
};

export const DATA_QA_SECTION_PIM_MSG = 'section-pim-disclaimer';

const isPimProduct = (source?: string): boolean => {
  return source?.toLowerCase() === 'pim';
};

export const PimDisclaimer: React.FC<PimDisclaimerProps> = ({ className }) => {
  const { t } = useTranslation();
  const source = useSelector(getSource);

  if (!isPimProduct(source)) {
    return null;
  }

  return (
    <section
      className={cx(pdpSectionStyle, pimDisclaimerSection, className)}
      data-qa={DATA_QA_SECTION_PIM_MSG}
    >
      <Typography variant="minor" size="caption" color="text-minor" as="p">
        {t('pim-disclaimer.message')}
      </Typography>
    </section>
  );
};
